import { Collector } from '@debbie/common/dist/collectors/index.js'
import * as criiptoLib from '@debbie/cortex/dist/api/criipto.js'
import { c } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { setTenantId } from '@debbie/cortex/dist/tenant/index.js'
import ArrowRight from '@debbie/iris/dist/components/Icons/ArrowRight.js'
import { PlaceholderLoader, Table } from '@debbie/iris/dist/components/index.js'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import mitidLogoSrc from '../assets/images/mitid-logo.svg'
import { APIBASE } from '../config.js'

const Criipto = (props: { collector: Collector }) => {
  const { collector } = props
  const lang = useSelector((s: RootState) => s.lang)

  const [loading, setLoading] = useState<boolean>(false)
  const [casesToLogin, setCasesToLogin] = useState<
    | null
    | {
        authToken: string
        caseSeqId: number
        caseId: string
        creditorName: string
        caseReferenceId: string
      }[]
  >(null)

  const code = window.location
    ? new URLSearchParams(window.location.search).get('code')
    : null

  const goToCase = (auth: { caseSeqId: number; authToken: string }) => {
    c.auth.setToken(auth.authToken)
    setTenantId(collector.tenantId)

    location.replace(`/cases/${auth.caseSeqId}`)
  }

  useEffect(() => {
    const runAsync = async () => {
      if (collector && code) {
        setLoading(true)
        try {
          const auths = await criiptoLib.auth(
            collector.tenantId,
            code,
            window.location.origin,
          )

          if (auths.length === 1) {
            goToCase(auths[0])
          } else {
            setCasesToLogin(auths)
          }
        } catch (error) {}
        setLoading(false)
      }
    }
    runAsync()
  }, [code, collector])

  if (!collector.tenantId) {
    return null
  }

  return (
    <div>
      {loading ? (
        <div style={{ textAlign: 'left' }}>
          <PlaceholderLoader />
          <PlaceholderLoader width="60%" />
          <PlaceholderLoader width="75%" />
        </div>
      ) : (
        collector &&
        (casesToLogin && Array.isArray(casesToLogin) ? (
          <div>
            {casesToLogin.length === 0 ? (
              <h3>
                {lang.login.couldNotIdentifyYou} {collector.name}.
              </h3>
            ) : (
              <Table zebra style={{ textAlign: 'left' }}>
                {casesToLogin.map((_case) => (
                  <tr
                    key={_case.caseId}
                    onClick={() => {
                      goToCase(_case)
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <td>
                      <b>{_case.creditorName}</b>
                      <br />
                      {_case.caseReferenceId}
                    </td>
                    <td style={{ textAlign: 'right' }}>#{_case.caseSeqId}</td>
                  </tr>
                ))}
              </Table>
            )}
          </div>
        ) : (
          <div>
            <p>{lang.login.mitIdDescription}</p>
            <a
              style={{ color: 'white' }}
              href={`${APIBASE}/v1/criipto?tenantId=${
                collector.tenantId
              }&message=${encodeURIComponent(
                `Se dine data vedr. ${collector.name}.`,
              )}&redirectURL=${encodeURIComponent(
                window.location.origin,
              )}&acrValues=${encodeURIComponent('urn:grn:authn:dk:mitid:low')}`}
            >
              <div
                style={{
                  backgroundColor: '#0060E6',
                  borderRadius: '3px',
                  padding: '14px 10px 12px 15px',
                  textAlign: 'left',
                  marginBottom: '10px',
                }}
              >
                <img height="20" src={mitidLogoSrc} />
                <p style={{ float: 'right', margin: '0' }}>
                  {lang.login.loginWithMitId}{' '}
                  <ArrowRight
                    style={{
                      margin: '.2em 0 -.2em',
                    }}
                  />
                </p>
              </div>
            </a>
          </div>
        ))
      )}
    </div>
  )
}

export default Criipto
